<template>
  <div class="endpoints-status">
    <h3>Endpoints Status</h3>
    <div class="endpoints-container">
      <div class="endpoints-header">
        <div class="flex-1">Consulta</div>
        <div class="w-32 text-center">Status Plexi</div>
        <div class="w-40 text-right">Status Fonte</div>
      </div>

      <div class="endpoints-list divide-y divide-gray-100">
        <div v-if="loading" class="loading">
          <div class="spinner"></div>
          <span>Carregando endpoints...</span>
        </div>
        <div v-else v-for="endpoint in endpointsWithStatus" :key="endpoint.id">
          <div class="endpoint-item">
            <div class="flex-1">{{ endpoint.label }}</div>
            <div class="w-32 text-center">
              <div class="availability-badge" :class="endpoint.active ? '-active' : '-inactive'">
                {{ endpoint.active ? 'Ativo' : 'Inativo' }}
              </div>
            </div>
            <div class="w-40 text-right">
              <div class="badge" :class=" getStatusClass(endpoint.status)">{{ translateStatus(endpoint.status) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import statusMixin from '../mixins/statusMixin';

export default {
  name: 'EndpointsStatus',
  mixins: [statusMixin],

  computed: {
    ...mapState({
      endpoints: (state) => state.status.endpoints,
      activeIncidents: (state) => state.status.activeIncidents,
      loading: (state) => state.status.loading,
    }),

    endpointsWithStatus() {
      return this.endpoints.map((endpoint) => {
        const activeIncident = this.activeIncidents.find((incident) => incident.endpoint_id === endpoint.id);
        let status = 'stable';

        if (activeIncident) {
          const incidentStatus = activeIncident.status.toUpperCase();
          if (incidentStatus.includes('IN_MAINTENANCE')) {
            status = 'in_maintenance';
          } else if (['REPORTED', 'DETECTED', 'INVESTIGATING', 'IDENTIFIED', 'IN_PROGRESS'].some((s) => incidentStatus.includes(s))) {
            status = 'unstable';
          }
        }

        return {
          ...endpoint,
          active: endpoint.active ?? true,
          status,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.endpoints-status {
  margin-left: -10px;
  margin-right: -10px;
  @apply mt-8;

  h3 {
    @apply text-lg;
    @apply font-semibold;
    @apply mb-4;
  }
}

.endpoints-container {
  width: 100%;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.endpoints-header {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  font-weight: 500;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
  background-color: #f9fafb;
}

.endpoint-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f9fafb;
  }
}

.availability-badge {
  @apply px-3;
  @apply py-1;
  @apply rounded-full;
  @apply text-sm;
  @apply font-medium;
  @apply inline-block;

  &.-active {
    @apply bg-blue-100;
    @apply text-blue-800;
  }

  &.-inactive {
    @apply bg-gray-100;
    @apply text-gray-800;
  }
}

.badge {
  @apply px-3;
  @apply py-1;
  @apply rounded-full;
  @apply text-sm;
  @apply font-medium;

  &.-success {
    @apply bg-green-100;
    @apply text-green-800;
  }

  &.-warning {
    @apply bg-yellow-100;
    @apply text-yellow-800;
  }

  &.-info {
    @apply bg-blue-100;
    @apply text-blue-800;
  }

  &.-danger {
    @apply bg-red-100;
    @apply text-red-800;
  }
}
</style>
